










import { Component, Vue } from 'vue-property-decorator';
import { ISearchResult, IProgram, SearchType, ICourse } from '../Scripts/ISearchService';
// Still unsure if it is ok to remove - import { BvEvent } from 'bootstrap-vue';

import ResultPanel from './ResultPanel.vue';

import RequestMoreInfo from './RequestMoreInfo.vue';

@Component({
	components: {
		ResultPanel, RequestMoreInfo
	}
})
export default class ResultsPanel extends Vue {
	private rmiItem: IProgram | ICourse | null = null;

	get results (): ISearchResult {
		return this.$store.state.result as ISearchResult;
	}

	get searchType (): SearchType {
		return this.results.searchType;
	}

	private requestMoreInfo (item: IProgram | ICourse) {
		this.rmiItem = item;
		this.$bvModal.show('rmi');
	}
}
